import { Button, Card, Space, Typography } from "antd"
import Layout from "modules/layout/dashboard"
import { useInvoiceId, useMemberId } from "pages/member"
import { useMember } from "pages/member/queries"
import { useInvoice } from "../../queries"
import { useNavigate } from "react-router-dom"
import InteracLogo from "assets/interac-logo.webp"
import styles from "./styles.module.scss"
import { Trans, useTranslation } from "react-i18next"
import { useEffect } from "react"
const { Main } = Layout
const { Title, Text } = Typography
const Payment: React.FC = () => {
  const { t } = useTranslation()
  const memberId = useMemberId()
  const member = useMember(memberId)
  const invoiceId = useInvoiceId()
  const invoice = useInvoice(memberId!, invoiceId!)
  const navigate = useNavigate()

  useEffect(() => {
    invoice.data &&
      ["paid", "recoverable", "canceled"].includes(invoice.data?.status!) &&
      navigate("../")
  }, [invoice.data])

  return (
    <>
      <Main.PageHeader
        breadcrumbs={[
          {
            title: member.data?.name,
            link: `/members/${member.data?.id}/events`,
          },
          { title: "Factures", link: `/members/${member.data?.id}/invoices` },
          {
            title:
              invoice.data?.reference ??
              invoice.data?.proforma_reference ??
              "-",
            link: `/members/${member.data?.id}/invoices/${invoice.data?.id}`,
          },
          { title: t("invoice.payment") },
        ]}
        title={
          <Title level={3}>
            {t("invoice.text_1")} No:{" "}
            {invoice.data?.reference ?? invoice.data?.proforma_reference ?? "-"}
          </Title>
        }
      />
      <Card>
        <Space direction="vertical" size={"large"}>
          <Button
            type="primary"
            size="large"
            onClick={() => navigate("pay_invoice")}
          >
            {t("invoice.pay_my_invoice_online")}
          </Button>

          <h2 className="headline-heavy">{t("invoice.payment_other_way")}</h2>
          <Text>{t("invoice.payment_other_way_msg")}</Text>

          <h2 className="title-heavy">{t("invoice.payment_other")}</h2>
          <Text>
            <Button
              type="link"
              onClick={() =>
                window.open(
                  new URL(
                    `operation/administration/members/${memberId}/invoices/${invoiceId}/export`,
                    process.env.REACT_APP_API_URL
                  ).href
                )
              }
              style={{
                padding: 0,
              }}
            >
              {t("invoice.download_invoice")}
            </Button>
            {t("invoice.payment_other_msg")}
          </Text>

          <h2 className="title-heavy">
            Interac{" "}
            <img
              src={InteracLogo}
              className={styles.interacImg}
              alt="Interac"
            />
          </h2>
          <div>
            <Text>{t("invoice.text_2")} :</Text>
            <ol>
              <li>
                <Text>
                  <Trans
                    i18nKey={"invoice.text_3"}
                    t={t}
                    components={[<Text strong>interac payment recipient</Text>]}
                  />
                </Text>
              </li>
              <li>
                <Text>
                  {t("invoice.text_4")}
                  <Text strong>
                    {" "}
                    (
                    {invoice.data?.reference ??
                      invoice.data?.proforma_reference}
                    )
                  </Text>
                </Text>
              </li>
              <li>
                <Text>
                  <Trans
                    i18nKey={"invoice.text_5"}
                    t={t}
                    components={[<Text strong>interac code</Text>]}
                  />
                </Text>
              </li>
            </ol>
            <Text>{t("invoice.text_6")}</Text>
          </div>
        </Space>
      </Card>
    </>
  )
}

export default Payment
